import {classNames} from "primereact/utils";
import {ProgressBar} from "primereact/progressbar";
import {Badge} from "primereact/badge";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Button} from "primereact/button";
import {getTempUrl, uploadTempUrl} from "../../../../redux/api/apiMonitoringList";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {changeRecallNumber, setRecallNumber} from "../../../../redux/actions/actionsWebRTC";
import {getGroupSessionId} from "../../../../utils/callSessionUtils";
import {Divider} from "primereact/divider";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import {SET_USER_STATUS_ERROR, SET_USER_STATUS_SUCCESS} from "../../../../redux/types/typesUsersList";
import AudioPlayer from "../../../Monitoring/AudioPlayer";
import {Dropdown} from "primereact/dropdown";
import {setIsSpeacking} from "../../../../redux/actions/actionsMonitoringList";
import {setEditType} from "../../../../redux/actions/actions";
import {
    setAudioControlDialogVisible,
    setAudioControlErrorField,
    setSelectedAudioControlIndex,
} from "../../../../redux/actions/actionsAudioControl";
import {getAudioControlById} from "../../../../redux/api/apiAudioControl";
import {getEventStatisticToUserDetail} from "../../../../redux/api/apiStatisticsList";
import {getQualityControlStatisticToUserDetail} from "../../../../redux/api/apiQualityControlStatistics";
import AudioControlDialog from "../../../Settings/AudioControlList/AudioControlDialog";
import ManualEvaluationDialog from "../../ManualEvaluationDialog";
import ControlResultViewDialog from "../../ControlResultViewDialog";
import {getQuestionnaireStatusMeta} from "../../ManualEvaluationDialog/manualEvaluationQuestionnaires";

const StatisticsListDetails = (props: any) => {
    const dispatch = useAppDispatch();
    const qualityControlMode = Boolean(props.qualityControlMode);
    const statisticData = useAppSelector(state => qualityControlMode
        ? state.QualityControlStatisticsReducer?.statisticData
        : state.StatisticsListReducer?.statisticData);
    const ratedQuestionnaires = useAppSelector(state => qualityControlMode
        ? state.QualityControlStatisticsReducer?.ratedQuestionnaires ?? []
        : state.StatisticsListReducer?.ratedQuestionnaires ?? []);
    const detailsLoading = useAppSelector(state => qualityControlMode
        ? state.QualityControlStatisticsReducer.detailsLoading
        : state.StatisticsListReducer.detailsLoading);
    const hasRatedQuestionnaires = ratedQuestionnaires.length > 0;
    const statusDictionary = useAppSelector(state => state.MonitoringListReducer.statusDictionary);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const playerPermissions = checkPermissions(rolesVision, qualityControlMode ? 'QualityControlStatistic' : 'Statistic');
    const playerRecordingPermissions = checkPermissions(rolesVision, 'Player');
    const spyPermissions = checkPermissions(rolesVision, 'SpyCall');
    const {visible: hasSpyVisionPermission} = spyPermissions;
    const audioUrl = useAppSelector(state => state.MonitoringListReducer.audioUrl);
    const audioUrlLoading = useAppSelector(state => state.MonitoringListReducer.audioUrlLoading);
    const audioUrlUploadLoading = useAppSelector(state => state.MonitoringListReducer.audioUrlUploadLoading);
    const recallNumberChanged = useAppSelector(state => state.WebRTCReducer.recallNumberChanged);
    const sipUserBusy = useAppSelector(state => state.WebRTCReducer.sipUserBusy);
    const [timeStamp, setTimeStamp] = useState<any>(null);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const [visible, setVisible] = useState(false);
    const [evaluationVisible, setEvaluationVisible] = useState(false);
    const [controlResultVisible, setControlResultVisible] = useState(false);
    const [evaluatedAudioControlId, setEvaluatedAudioControlId] = useState<number | null>(null);
    const [selectedRatedQuestionnaireId, setSelectedRatedQuestionnaireId] = useState<number | null>(null);
    const audioControlPermissions = checkPermissions(rolesVision, 'QualityControl');
    const qualityControlStatisticPermissions = checkPermissions(rolesVision, 'QualityControlStatistic');
    const {
        visible: hasAudioControlVisiblePermission,
        update: hasAudioControlUpdatePermission,
    } = audioControlPermissions;
    const {
        visible: hasQualityControlStatisticVisiblePermission,
        create: hasQualityControlStatisticCreatePermission,
    } = qualityControlStatisticPermissions;
    const callResetDictionary = useAppSelector(state => state.MonitoringListReducer.callResetDictionary);
    const forcedClosingDictionary = useAppSelector(state => state.MonitoringListReducer.forcedClosingDictionary);
    const ownerTypeDictionary = useAppSelector(state => state.MonitoringListReducer.ownerTypeDictionary);
    const [loader, setLoader] = useState(false);
    // @ts-ignore
    const isSpeakingAudio = useAppSelector(state => state.MonitoringListReducer.isSpeakingAudio);
    const [validAudioUrl, setValidAudioUrl] = useState<any[]>([]);
    const audioOptions = [
        ...(validAudioUrl?.some(item => item.audioType === 1)
            ? [{name: 'Запис розмови', code: 1}]
            : []),
        ...(validAudioUrl?.some(item => item.audioType === 2)
            ? [{name: 'Запис дзвінка', code: 2}]
            : []),
    ];
    const hasAudioType1 = validAudioUrl?.some((item: { audioType: number; }) => item?.audioType === 1);
    const hasAudioType2 = validAudioUrl?.some((item: { audioType: number; }) => item?.audioType === 2);
    const isDropdownEnabled = hasAudioType1 && hasAudioType2;
    const {
        visible: hasPlayerVisiblePermission,
        update: hasPlayerUpdatePermission,
    } = playerPermissions;
    const {
        visible: hasPlayerRecordingVisiblePermission,
    } = playerRecordingPermissions;
    const hasCallEvaluationViewPermission = hasQualityControlStatisticVisiblePermission
        && hasPlayerRecordingVisiblePermission;
    const hasCallEvaluationCreatePermission = hasQualityControlStatisticCreatePermission
        && hasPlayerRecordingVisiblePermission;
    const hasCallEvaluationPermission = hasCallEvaluationViewPermission || hasCallEvaluationCreatePermission;

    let foundStatus = statusDictionary?.filter((status: any) => status?.dictionaryId === statisticData?.status);

    const statusClass = classNames({
        'p-badge status-active': foundStatus?.[0]?.dictionaryId === 101,
        'p-badge status-success': foundStatus?.[0]?.dictionaryId === 103,
        'p-badge status-unsuccessful': foundStatus?.[0]?.dictionaryId === 104,
        'p-badge status-action': foundStatus?.[0]?.dictionaryId === 'ACTION',
        'p-badge status-processing': foundStatus?.[0]?.dictionaryId === 102
    });

    useEffect(() => {
        setEvaluatedAudioControlId(null);
        setSelectedRatedQuestionnaireId(null);
    }, [statisticData?.id]);

    useEffect(() => {
        if (!validAudioUrl || validAudioUrl.length === 0) {
            dispatch(setIsSpeacking(null));
            return;
        }

        const hasAudioType1 = validAudioUrl.some((item: { audioType: number; }) => item.audioType === 1);
        const hasAudioType2 = validAudioUrl.some((item: { audioType: number; }) => item.audioType === 2);

        if (hasAudioType1) {
            dispatch(setIsSpeacking({name: 'Запис розмови', code: 1}));
        } else if (hasAudioType2) {
            dispatch(setIsSpeacking({name: 'Запис дзвінка', code: 2}));
        } else {
            dispatch(setIsSpeacking(null));
        }
    }, [validAudioUrl]);

    useEffect(() => {
        if (!audioUrl || audioUrl.length === 0) {
            setValidAudioUrl([]);
            return;
        }

        const audioElements = audioUrl.map((url: any) =>
            new Promise((resolve) => {
                const audio = new Audio();
                audio.src = url.tempUrl;

                audio.onloadedmetadata = () => {
                    if (audio.duration >= 0.6) {
                        resolve(url);
                    } else {
                        resolve(null);
                    }
                };

                audio.onerror = () => resolve(null);
            })
        );

        Promise.all(audioElements).then((results) => {
            const filtered = results.filter(Boolean);
            setValidAudioUrl(filtered as any[]);
        });
    }, [audioUrl]);

    const handlePlay = useCallback(() => {
        setTimeStamp(null);
        dispatch(getTempUrl(jwtToken?.jwtToken, statisticData?.sessionId, statisticData?.id));
    }, [dispatch, jwtToken?.jwtToken, statisticData?.sessionId, statisticData?.id]);

    const checkBanUser = () => {
        let data = {
            nameTo: statisticData?.ani,
            sessionId: getGroupSessionId(statisticData),
        }
        dispatch(setRecallNumber(data));
        dispatch(changeRecallNumber(!recallNumberChanged));
        if (windowWidth <= 1248) {
            props.setSelectedRowData(null);
            props.setSelectedRowExpansion(null);
        }
    }

    const checkSpySession = () => {
        // let data = {
        //     nameTo: statisticData?.ani || statisticData?.aNI,
        //     sessionId: statisticData?.groupSessionId
        // }
        // dispatch(setRecallNumber(data));
        // dispatch(changeRecallNumber(!recallNumberChanged));
        // if (windowWidth <= 1248) {
        //     props.setSelectedRowData(null);
        //     props.setSelectedRowExpansion(null);
        // }
    }

    const canSpy = statisticData?.status === 101;
    const spyHeadphonesDisabled = !canSpy || sipUserBusy;

    const audioHeaderBody = () => {
        return <div>Запис дзвінка</div>
    }

    const copyAudio = (validAudioUrl: any) => {
        const audioType1 = validAudioUrl?.filter((item: { audioType: number; }) => item?.audioType === 1);
        const audioType2 = validAudioUrl?.filter((item: { audioType: number; }) => item?.audioType === 2);
        const src = isSpeakingAudio?.code === 1
            ? audioType1?.[0]?.tempUrl
            : isSpeakingAudio?.code === 2
                ? audioType2?.[0]?.tempUrl
                : null;
        const copyToClipboard = (text: string) => {
            const tempElement = document.createElement('textarea');
            tempElement.value = text;
            document.body.appendChild(tempElement);
            tempElement.select();
            document.execCommand('copy');
            document.body.removeChild(tempElement);
        }
        copyToClipboard(src);
        dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: 'Посилання аудіо скопійована в буфер обміну'}});
    }

    const audioBodyTemplate = () => {
        return hasPlayerVisiblePermission ? <>{(
            <div className="field col-12 md:col-12 flex align-items-center mb-0">
                <Button icon="pi pi-caret-right"
                        disabled={statisticData?.status === 101 || statisticData?.status === 102}
                        loading={audioUrlLoading} onClick={() => {
                    handlePlay();
                    setVisible(true);
                }} className="bg-primary" label="Прослухати"/>
            </div>)}
            {audioUrl &&
                <Dialog header={audioHeaderBody} visible={visible} style={{width: '25vw'}} className="pb-0 audio-dialog"
                        onHide={() => setVisible(false)}>
                    <div
                        className={`field col-12 md:col-12 flex flex-column align-items-center relative absolute outline-none border-none shadow-none border-circle save-mp3 text-lg mt-3 m-0 ${!audioUrl && 'opacity-40'}`}>
                        <Dropdown disabled={loader || !isDropdownEnabled} filter value={isSpeakingAudio}
                                  onChange={(e) => dispatch(setIsSpeacking(e.value))} options={audioOptions}
                                  optionLabel="name"
                                  className="w-full mt-2 mb-3"/>
                        <div className="w-full relative">
                            <AudioPlayer audioUrl={validAudioUrl} handleResetPlayer={props.handleResetPlayer}
                                         timeStamp={timeStamp}
                                         setTimeStamp={setTimeStamp}/>
                            {hasPlayerUpdatePermission && <Button
                                onClick={() => dispatch(uploadTempUrl(jwtToken?.jwtToken, statisticData?.sessionId, statisticData?.id, isSpeakingAudio))}
                                disabled={!validAudioUrl} icon="pi pi-download"
                                loading={audioUrlUploadLoading}
                                style={{marginLeft: '10px'}}
                                className={`absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ${validAudioUrl ? 'opacity-100' : 'opacity-50'}`}
                            />}
                            {hasPlayerVisiblePermission && <Button
                                onClick={() => copyAudio(validAudioUrl)}
                                disabled={!validAudioUrl} icon="pi pi-copy"
                                style={{marginLeft: '10px'}}
                                className={`absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ml-6 ${validAudioUrl ? 'opacity-100' : 'opacity-50'}`}
                            />}
                        </div>
                    </div>
                </Dialog>}
        </> : ''
    }

    const formatDateTime = (dateTimeStr: string): string => {
        const date = new Date(dateTimeStr);

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${hours}:${minutes}:${seconds} ${day}/${month}/${year}`;
    };

    // const convertMillisecondsToTime = (totalMilliseconds: number): string => {
    //     const hours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
    //     const minutes = Math.floor((totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    //     const seconds = Math.floor((totalMilliseconds % (1000 * 60)) / 1000);
    //
    //     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    // };

    const convertSecondsToTime = (totalSeconds: number): string => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    const foundCallReset = callResetDictionary?.filter((item: any) => item?.dictionaryId === statisticData?.callReset);
    const foundAmdHangup = forcedClosingDictionary?.filter((item: any) => item?.dictionaryId === statisticData?.forcedClosing);
    let foundOwnerType = ownerTypeDictionary?.filter((status: any) => status?.dictionaryId === statisticData?.ownerType);

    const fields = [
        {label: "Оператор", value: statisticData.fullName || '- - -'},
        ...(statisticData?.campaignName || statisticData?.queueName ? [{label: statisticData?.campaignName ? 'Кампанія' : 'Черга', value: statisticData.campaignName || statisticData.queueName}] : []),
        ...(statisticData?.campaignId || statisticData?.queueId ? [{label: statisticData?.campaignId ? 'ID кампанії' : 'ID Черги', value: statisticData.campaignId || statisticData.queueId}] : []),
        {label: "Транк", value: statisticData?.aNumber || '- - -'},
        {label: "Тривалість дзвінка", value: statisticData.fullCallDuration && statisticData?.fullCallDuration !== -1 ? convertSecondsToTime(statisticData.fullCallDuration) : statisticData.fullCallDuration === 0 ? '00:00:00' : '- - -'},
        {label: "Тривалість розмови", value: statisticData.duration && statisticData.duration !== -1 ? convertSecondsToTime(statisticData.duration) : statisticData.duration === 0 ? '00:00:00' : '- - -'},
        {label: "Реакція Клієнта", value: statisticData.reactionClient && statisticData.reactionClient !== -1 ? convertSecondsToTime(statisticData.reactionClient) : statisticData.reactionClient === 0 ? '00:00:00' : '- - -'},
        {label: "Реакція Оператора", value: statisticData.reactionOperator && statisticData.reactionOperator !== -1 ? convertSecondsToTime(statisticData.reactionOperator) : statisticData.reactionOperator === 0 ? '00:00:00' : '- - -'},
        {label: "Завершив", value: foundCallReset?.[0]?.name || '- - -'},
        {label: "Причина завершення", value: foundAmdHangup?.[0]?.name || '- - -'},
        {label: "Початок", value: statisticData.start ? formatDateTime(statisticData.start) : '- - -'},
        {label: "Завершення", value: statisticData.end ? formatDateTime(statisticData.end) : '- - -'},
    ];

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const copyDetailsLink = () => {
        let href = window.location.origin + '#/call_details/' + statisticData?.id
        const copyToClipboard = (text: string) => {
            const tempElement = document.createElement('textarea');
            tempElement.value = text;
            document.body.appendChild(tempElement);
            tempElement.select();
            document.execCommand('copy');
            document.body.removeChild(tempElement);
        }
        copyToClipboard(href);
        dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: 'Посилання скопійована в буфер обміну'}});
    }

    const openDetailsLink = () => {
        let href = window.location.origin + '#/call_details/' + statisticData?.id + '?childWindow=1'
        window.open(href, '_blank')
    }

    const openAudioControlDialog = () => {
        if (!statisticData?.audioControlId) {
            return;
        }
        dispatch(setSelectedAudioControlIndex(statisticData.audioControlId));
        dispatch(setAudioControlErrorField(null));
        dispatch(getAudioControlById(statisticData.audioControlId, jwtToken?.jwtToken));
        dispatch(setEditType(false));
        dispatch(setAudioControlDialogVisible(true));
    };

    const getStatisticQualityControlId = () =>
        statisticData?.audioControlId ?? statisticData?.qualityControlId ?? null;

    const ratedQuestionnairesCount = ratedQuestionnaires.length;
    const ratedQuestionnairesCountLabel = `Кількість оцінок: ${ratedQuestionnairesCount}`;

    const evaluationActionsLayoutStyle: React.CSSProperties = qualityControlMode
        ? {
            display: 'inline-flex',
            alignItems: 'center',
        }
        : {
            display: 'inline-grid',
            gridTemplateColumns: 'minmax(11rem, max-content) max-content',
            columnGap: '0.5rem',
            alignItems: 'end',
        };
    const evaluationViewColumnClassName = 'flex flex-column align-items-center';

    const evaluationColumnHeader = () => (
        <div style={evaluationActionsLayoutStyle}>
            <span>Оцінка</span>
            {!qualityControlMode && (
                <div className={evaluationViewColumnClassName}>
                    <span className="text-sm white-space-nowrap">{ratedQuestionnairesCountLabel}</span>
                </div>
            )}
        </div>
    );

    const evaluationBodyTemplate = () => {
        return (
            <div style={evaluationActionsLayoutStyle}>
                {hasCallEvaluationCreatePermission && (
                    <Button
                        label="Оцінити дзвінок"
                        className="p-button-sm"
                        onClick={openEvaluationDialog}
                    />
                )}
                {!qualityControlMode && hasCallEvaluationViewPermission && (
                    <div className={evaluationViewColumnClassName}>
                        {hasRatedQuestionnaires && (
                            <Button
                                label="Переглянути оцінку"
                                icon="pi pi-eye"
                                className="p-button-sm"
                                disabled={!statisticData?.id}
                                onClick={() => handleViewEvaluation()}
                            />
                        )}
                    </div>
                )}
            </div>
        );
    };

    const openEvaluationDialog = () => {
        setEvaluationVisible(true);
    };

    const closeEvaluationDialog = () => {
        setEvaluationVisible(false);
    };

    const handleEvaluationSubmitted = (payload: { audioControlId: number | null; callId?: number | null }) => {
        if (payload.audioControlId) {
            setEvaluatedAudioControlId(payload.audioControlId);
        }

        const callId = payload.callId ?? statisticData?.id;
        if (callId && jwtToken?.jwtToken) {
            dispatch(qualityControlMode
                ? getQualityControlStatisticToUserDetail(callId, jwtToken.jwtToken)
                : getEventStatisticToUserDetail(callId, jwtToken.jwtToken));
        }
    };

    const handleViewEvaluation = (formId?: number | null) => {
        if (!statisticData?.id) {
            dispatch({
                type: SET_USER_STATUS_ERROR,
                payload: {message: 'Неможливо завантажити оцінку для цього дзвінка'},
            });
            return;
        }

        const qualityControlId = formId
            ?? selectedRatedQuestionnaireId
            ?? evaluatedAudioControlId
            ?? getStatisticQualityControlId()
            ?? ratedQuestionnaires[0]?.id
            ?? null;

        if (qualityControlId) {
            setEvaluatedAudioControlId(qualityControlId);
        }

        setControlResultVisible(true);
    };

    const formatEvaluationScore = (score: number | null | undefined) => {
        if (score == null || !Number.isFinite(Number(score))) {
            return '- - -';
        }

        return `${Number(score)}%`;
    };

    const getEvaluationScoreClassName = (score: number | null | undefined) => {
        const numericScore = Number(score);
        if (score == null || !Number.isFinite(numericScore)) {
            return undefined;
        }

        if (numericScore >= 100) {
            return 'text-green-500 font-bold';
        }

        if (numericScore >= 50) {
            return 'text-yellow-500 font-bold';
        }

        return 'text-red-500 font-bold';
    };

    const formatEvaluationMetaDateTime = (dateTimeStr?: string | null) => {
        if (!dateTimeStr) {
            return '- - -';
        }

        const date = new Date(dateTimeStr);
        if (Number.isNaN(date.getTime())) {
            return '- - -';
        }

        return date.toLocaleString('uk-UA');
    };

    const sortedRatedQuestionnaires = useMemo(() => {
        return [...ratedQuestionnaires].sort((left, right) => {
            const leftTime = left.dateTimeEnd ? new Date(left.dateTimeEnd).getTime() : 0;
            const rightTime = right.dateTimeEnd ? new Date(right.dateTimeEnd).getTime() : 0;
            return rightTime - leftTime;
        });
    }, [ratedQuestionnaires]);

    const preferredQuestionnaireId = props.preferredQuestionnaireId != null
        ? Number(props.preferredQuestionnaireId)
        : null;

    useEffect(() => {
        if (!sortedRatedQuestionnaires.length) {
            setSelectedRatedQuestionnaireId(null);
            return;
        }

        const preferredMatch = Number.isFinite(preferredQuestionnaireId)
            ? sortedRatedQuestionnaires.find((item) => item.id === preferredQuestionnaireId)
            : undefined;

        setSelectedRatedQuestionnaireId((currentId) => {
            if (preferredMatch) {
                return preferredMatch.id;
            }

            if (currentId != null && sortedRatedQuestionnaires.some((item) => item.id === currentId)) {
                return currentId;
            }

            return sortedRatedQuestionnaires[0].id;
        });
    }, [sortedRatedQuestionnaires, preferredQuestionnaireId]);

    const selectedRatedQuestionnaire = sortedRatedQuestionnaires.find((item) => item.id === selectedRatedQuestionnaireId)
        ?? sortedRatedQuestionnaires[0]
        ?? null;
    const selectedRatedQuestionnaireStatusMeta = selectedRatedQuestionnaire
        ? getQuestionnaireStatusMeta(selectedRatedQuestionnaire.status, {isRated: true})
        : null;

    const evaluationHeaderPanel = qualityControlMode && hasRatedQuestionnaires && hasCallEvaluationViewPermission ? (
        <div className="flex flex-column w-full min-w-0">
            <div className="flex flex-wrap align-items-center gap-2 pl-2">
                <label className="mb-0 white-space-nowrap">Анкета</label>
                <Dropdown
                    value={selectedRatedQuestionnaireId}
                    options={sortedRatedQuestionnaires}
                    optionLabel="searchLabel"
                    optionValue="id"
                    dataKey="id"
                    filter={sortedRatedQuestionnaires.length > 1}
                    filterPlaceholder="Введіть назву"
                    resetFilterOnHide
                    onChange={(event) => setSelectedRatedQuestionnaireId(event.value ?? null)}
                    placeholder="Оберіть анкету"
                    style={{minWidth: '160px', maxWidth: '280px'}}
                />
                <div className="flex align-items-stretch gap-2">
                    {selectedRatedQuestionnaireStatusMeta && (
                        <Badge
                            value={selectedRatedQuestionnaireStatusMeta.label}
                            className={`manual-evaluation-status-badge ${selectedRatedQuestionnaireStatusMeta.badgeClassName} text-white customer-badge text-xs p-0 flex align-items-center justify-content-center`}
                            style={{
                                maxWidth: '110px',
                                minWidth: '110px',
                                height: 'auto',
                                lineHeight: 'normal',
                                borderRadius: '6px',
                            }}
                        />
                    )}
                    <Button
                        label="Переглянути оцінку"
                        icon="pi pi-eye"
                        className="p-button-sm"
                        disabled={!statisticData?.id || !selectedRatedQuestionnaire?.id}
                        onClick={() => handleViewEvaluation(selectedRatedQuestionnaire?.id)}
                    />
                </div>
            </div>
            {selectedRatedQuestionnaire && (
                <div className="grid w-full m-0 mt-2">
                    <div className="col-12 md:col-2 flex align-items-center m-0">
                        <p className="m-0">
                            Оцінювач: {selectedRatedQuestionnaire.userFullName || '- - -'}
                        </p>
                    </div>
                    <div className="col-12 md:col-2 flex align-items-center m-0">
                        <p className="m-0">
                            Дата оцінки: {formatEvaluationMetaDateTime(selectedRatedQuestionnaire.dateTimeEnd)}
                        </p>
                    </div>
                    <div className="col-12 md:col-2 flex align-items-center m-0">
                        <p className="m-0">
                            Оцінка:{' '}
                            <span className={getEvaluationScoreClassName(selectedRatedQuestionnaire.score)}>
                                {formatEvaluationScore(selectedRatedQuestionnaire.score)}
                            </span>
                        </p>
                    </div>
                </div>
            )}
        </div>
    ) : null;

    return (
        <div className="relative">
            {detailsLoading && <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>}
            <div className={classNames('grid', {'opacity-50': detailsLoading})}
                 style={{paddingTop: "0.3rem", padding: '0.3rem 10px 5px'}}>
                {windowWidth > 1248 &&
                    <div className="grid col-12 md:col-12 mb-0 px-0 w-full justify-content-between">
                        <div className="absolute top-0 right-0 flex">
                            <button className="close-button block cursor-pointer ml-auto mr-2"
                                    onClick={() => {
                                        copyDetailsLink();
                                    }
                                    }><span className="pi pi-copy"></span>
                            </button>
                            {!props.isWindow && <button className="close-button block cursor-pointer ml-auto mr-2"
                                                        onClick={() => {
                                                            openDetailsLink();
                                                        }
                                                        }><span
                                className="pi pi-arrow-up-right-and-arrow-down-left-from-center"></span>
                            </button>}
                            {!props.isWindow && <button className="close-button block cursor-pointer ml-auto"
                                                        onClick={() => {
                                                            props.setSelectedRowData(null);
                                                            props.setSelectedRowExpansion(null);
                                                        }
                                                        }><span className="pi pi-times"></span>
                            </button>}
                        </div>
                        <div className="field col-12 md:col-4 flex align-items-center m-0">
                            <div className="field col-12 md:col-5 flex m-0 py-0 flex-column flex-shrink-0 justify-content-center">
                                {statisticData.contactName?.trim() ? (
                                    statisticData.pathSegment ?
                                        <a target="_blank" className="mb-2"
                                           href={`${statisticData.pathSegment}?sessionId=${statisticData?.sessionId}`}>{statisticData.contactName}</a> :
                                        <p className="m-0 mb-2">{statisticData.contactName}</p>
                                ) : null}
                                <div className="flex align-items-center">
                                    <div className="mr-2">{statisticData?.ani}</div>
                                </div>
                            </div>
                            <div className="field col-12 md:col-7 flex align-items-center m-0 py-0 min-w-0">
                                <Button icon="pi pi-phone" className="status-success border-none max-w-9rem mr-2 flex-shrink-0"
                                        style={{borderRadius: '6px'}} onClick={() => {
                                    checkBanUser();
                                }}></Button>
                                {hasSpyVisionPermission && <Button disabled={spyHeadphonesDisabled} icon="pi pi-headphones"
                                        className="status-success border-none max-w-9rem mr-2 flex-shrink-0"
                                        style={{background: 'rgb(253, 166, 16)'}} onClick={() => {
                                    checkSpySession();
                                }}></Button>}
                            </div>
                        </div>
                        <div className="field col-12 md:col-3 flex align-items-center justify-content-end m-0 pr-4">
                            <div className="field col-12 md:col-12 flex align-items-center m-0 p-0">
                                <div className="field col-6 md:col-7 flex align-items-center justify-content-end mb-0">
                                    {
                                        statisticData?.callType === 'transferInternal' && !statisticData.isDeclined ? (
                                            <div className="relative">
                                                <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
                                                   style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
                                            </div>
                                        ) : statisticData?.callType === 'transferInternal' && statisticData.isDeclined ? (
                                                <div className="relative">
                                                    <i className="pi pi-reply p-2 bg-green-500 border-circle text-white"
                                                       style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
                                                    <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                        <div className="border-circle relative"
                                                             style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                            <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                               style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                        </div>
                                                    </div>
                                                </div>) :

                                            statisticData?.callType === 'transferExternal' && !statisticData.isDeclined ? (
                                                <div className="relative">
                                                    <i className="pi pi-reply p-2 bg-primary border-circle text-white"
                                                       style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                                                </div>
                                            ) : statisticData?.callType === 'transferInternal' && statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-reply p-2 bg-primary border-circle text-white"
                                                           style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) :

                                                statisticData.callType === 'callback' ? (
                                                    <div className="relative">
                                                        <i className="pi pi-undo p-2 border-circle text-white"
                                                           style={{backgroundColor: "#fda610"}}></i>
                                                    </div>
                                                ) : statisticData.callType === 'internal' && !statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                                                    </div>
                                                ) : statisticData?.callType === 'callbackExternal' && !statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-undo p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative bg-primary"
                                                                 style={{width: '14px', height: '14px'}}>
                                                                <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : statisticData?.callType === 'callbackInternal' && !statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-undo p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative bg-green-500"
                                                                 style={{width: '14px', height: '14px'}}>
                                                                <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : (statisticData?.callType === 'callbackInternal' || statisticData?.callType === 'callbackExternal') && statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-undo p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : statisticData.callType === 'internal' && statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : statisticData?.callType === 'external' && !statisticData.isDeclined ? (
                                                    <>
                                                        <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                                                    </>
                                                ) : statisticData?.callType === 'external' && statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : statisticData?.callType === 'ivm' && !statisticData.isDeclined ? (
                                                    <>
                                                        <i className="bg-primary p-2 border-circle text-white font-bold relative"
                                                           style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                                                            className="absolute"
                                                            style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVM</span></i>
                                                    </>
                                                ) : statisticData?.callType === 'ivm' && statisticData.isDeclined ? (
                                                    <div className="relative inline-block">
                                                        <i className="bg-primary border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                                                           style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                                                            style={{fontSize: '11px'}}>IVM</span></i>
                                                        <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : statisticData?.callType === 'ivr' && !statisticData.isDeclined ? (
                                                    <>
                                                        <i className="bg-green-500 p-2 border-circle text-white font-bold relative"
                                                           style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                                                            className="absolute"
                                                            style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVR</span></i>
                                                    </>
                                                ) : statisticData?.callType === 'ivr' && statisticData.isDeclined ? (
                                                    <div className="relative inline-block">
                                                        <i className="bg-green-500 border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                                                           style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                                                            style={{fontSize: '11px'}}>IVR</span></i>
                                                        <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : statisticData?.callType === 'consultation' && !statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-users p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                    </div>
                                                ) : statisticData?.callType === 'consultation' && statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-users p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : statisticData?.callType === 'consultationExternal' && !statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-users p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative bg-primary"
                                                                 style={{width: '14px', height: '14px'}}>
                                                                <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : statisticData?.callType === 'consultationInternal' && !statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-users p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative bg-green-500"
                                                                 style={{width: '14px', height: '14px'}}>
                                                                <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (statisticData?.callType === 'consultationInternal' || statisticData?.callType === 'consultationExternal') && statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-users p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : (statisticData?.callType === 'pickupcall') && statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-user p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : statisticData?.callType === 'pickupcall' && !statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-user p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                    </div>) : (statisticData?.callType === 'spycall') && statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-headphones p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : statisticData?.callType === 'spycall' && !statisticData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-headphones p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                    </div>) : <div className="relative">
                                                    <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                                                </div>
                                    }
                                    <div className="ml-2 font-bold">
                                        {statisticData.direction}
                                    </div>
                                </div>
                                <div className="field col-6 md:col-3 flex align-items-center mb-0 py-0 pr-4">
                                    <Badge value={foundStatus?.[0]?.name}
                                           className={`${statusClass} text-white customer-badge text-xs mx-auto p-0`}
                                           style={{borderRadius: '6px', maxWidth: '95px', minWidth: '95px'}}/>
                                </div>
                            </div>

                        </div>
                        <Divider className="m-0 ml-2"/>
                        {evaluationHeaderPanel && (
                            <>
                                <div className="field col-12 flex align-items-center m-0 py-2 w-full">
                                    {evaluationHeaderPanel}
                                </div>
                                <Divider className="m-0 ml-2"/>
                            </>
                        )}
                        <div className="field col-12 md:col-9 flex align-items-center m-0 py-0 flex-wrap">
                            <div className="field col-12 md:col-2 flex align-items-center m-0">
                                <p>Власник дзвінка</p>
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0"
                                 style={{borderRight: `1px solid rgba(255, 255, 255, 0.15)`}}>
                                <p>{statisticData.ownerUserName || '- - -'}</p>
                            </div>
                            <div className="field col-12 md:col-2 flex m-0">
                                <p>Тип власника</p>
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0">
                                <p>{foundOwnerType?.[0]?.description || '- - -'}</p>
                            </div>
                            <div className="field col-12 md:col-2 flex m-0">
                                <p>Оператор</p>
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0"
                                 style={{borderRight: `1px solid rgba(255, 255, 255, 0.15)`}}>
                                <p>{statisticData.fullName || '- - -'}</p>
                            </div>
                            <div className="field col-12 md:col-2 flex align-items-center m-0">
                                {statisticData?.campaignId ? <p>ID / Назва Кампанii</p> : statisticData?.queueId ?
                                    <p>ID / Назва Черги</p> : <></>}
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0">
                                {statisticData?.campaignId ?
                                    <p>{statisticData?.campaignId} {statisticData?.campaignName}</p> :
                                    statisticData?.queueId ?
                                        <p>{statisticData?.queueId} {statisticData?.queueName}</p> :
                                        <></>
                                }
                            </div>
                            <div className="field col-12 md:col-6 flex m-0"
                                 style={{borderRight: `1px solid rgba(255, 255, 255, 0.15)`}}>
                            </div>
                            <div className="field col-12 md:col-2 flex m-0">
                                <p>Транк</p>
                            </div>
                            <div className="field col-12 md:col-4 flex m-0">
                                <p>{statisticData.aNumber || '- - -'}</p>
                            </div>
                        </div>
                        <div className="field col-12 md:col-3 flex m-0 py-0"
                             style={{borderLeft: `1px solid rgba(255, 255, 255, 0.15)`}}>
                            <div className="field col-12 md:col-4 flex m-0">
                                <p>Опис</p>
                            </div>
                            <div className="field col-4 md:col-8 flex m-0">
                                <p>{statisticData.description || '- - -'}</p>
                            </div>
                        </div>
                        <Divider className="m-0 ml-2"/>
                    </div>
                }
                {windowWidth <= 1248 && (statisticData.contactName || statisticData.pathSegment) &&
                    <div className="grid col-12 md:col-12 mb-0 px-0">
                        <div className="field col-12 md:col-12 flex align-items-center m-0">
                            {statisticData.pathSegment ?
                                <a target="_blank" className="mb-2"
                                   href={`${statisticData.pathSegment}?sessionId=${statisticData?.sessionId}`}>{statisticData.contactName}</a> :
                                <p className="m-0 mb-2">{statisticData.contactName}</p>}
                        </div>
                        {(statisticData.contactName || statisticData.pathSegment) && (
                            <div className="field col-12 md:col-12 p-0"
                                 style={{margin: 0, borderBottom: '1px solid #cccccc38'}}></div>)}
                    </div>}
                {windowWidth > 1248 && <React.Fragment>
                    <DataTable className="col-12 md:col-12 pl-0 py-0" value={[statisticData]}
                    >
                        <Column
                            header={'Тривалість дзвінка'}
                            className="justify-content-start"
                            body={(data) => data.fullCallDuration && data?.fullCallDuration !== -1 ? convertSecondsToTime(data.fullCallDuration) : data.fullCallDuration === 0 ? '00:00:00' : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Тривалість розмови'}
                            className="justify-content-start"
                            body={(data) => data.duration && data.duration !== -1 ? convertSecondsToTime(data.duration) : data.duration === 0 ? '00:00:00' : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Реакція Клієнта'}
                            className="justify-content-start"
                            body={(data) => data.reactionClient && data.reactionClient !== -1 ? convertSecondsToTime(data.reactionClient) : data.reactionClient === 0 ? '00:00:00' : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Реакція Оператора'}
                            className="justify-content-start"
                            body={(data) => data.reactionOperator && data.reactionOperator !== -1 ? convertSecondsToTime(data.reactionOperator) : data.reactionOperator === 0 ? '00:00:00' : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Початок'}
                            className="justify-content-start"
                            body={(data) => data.start ? formatDateTime(data.start) : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Завершення'}
                            className="justify-content-start"
                            body={(data) => data.end ? formatDateTime(data.end) : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Завершив'}
                            className="justify-content-start"
                            body={() => foundCallReset?.[0]?.name || '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Причина завершення'}
                            className="justify-content-start"
                            body={() => foundAmdHangup?.[0]?.name || '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        {hasCallEvaluationPermission && (
                            <Column
                                header={evaluationColumnHeader}
                                className="justify-content-start"
                                body={evaluationBodyTemplate}
                                style={{cursor: 'pointer', minWidth: '200px'}}
                            />
                        )}
                        <Column
                            header={'Запис дзвінка'}
                            className="justify-content-start"
                            body={audioBodyTemplate}
                            style={{cursor: 'pointer'}}
                        />
                    </DataTable>
                </React.Fragment>}
                {windowWidth <= 1248 && (
                    <React.Fragment>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>Клiент</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>{statisticData.ani}</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>Дія</p>
                        </div>
                        <div className="field col-12 md:col-7 flex align-items-center m-0">
                            <Button icon="pi pi-phone" className="status-success border-none max-w-9rem mr-2"
                                    style={{borderRadius: '6px'}} onClick={() => {
                                checkBanUser();
                            }}></Button>
                            {hasSpyVisionPermission && <Button disabled={spyHeadphonesDisabled} icon="pi pi-headphones"
                                    className="status-success border-none max-w-9rem mr-2"
                                    style={{background: 'rgb(253, 166, 16)'}} onClick={() => {
                                checkSpySession();
                            }}></Button>}
                        </div>
                        {evaluationHeaderPanel && (
                            <>
                                <Divider className="m-0 py-2"/>
                                <div className="field col-12 md:col-12 flex align-items-center m-0 py-2 w-full">
                                    {evaluationHeaderPanel}
                                </div>
                                <Divider className="m-0 py-2"/>
                            </>
                        )}
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>Власник дзвінка</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>{statisticData.ownerUserName || '- - -'}</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>Тип власника</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>{foundOwnerType?.[0]?.description || '- - -'}</p>
                        </div>
                        {fields.map((field: any) => (
                            <React.Fragment key={field.label}>
                                <div className="field col-12 md:col-5 flex align-items-center m-0">
                                    <p>{field.label}</p>
                                </div>
                                <div className="field col-12 md:col-7 flex align-items-center m-0">
                                    <p>{field.value}</p>
                                </div>
                            </React.Fragment>
                        ))}
                        <Divider className="m-0 py-3"/>
                        {hasAudioControlVisiblePermission && statisticData?.audioControlId && (
                            <div className="field col-12 md:col-12 flex align-items-center justify-content-center mb-2">
                                <Button
                                    icon={hasAudioControlUpdatePermission ? 'pi pi-pencil' : 'pi pi-eye'}
                                    label="Анкета"
                                    onClick={openAudioControlDialog}
                                />
                            </div>
                        )}
                        {hasCallEvaluationPermission && (
                            <div className="field col-12 md:col-12 flex flex-column align-items-center gap-2 mb-3">
                                <div style={evaluationActionsLayoutStyle}>
                                    <span>Оцінка</span>
                                    {!qualityControlMode && (
                                        <div className={evaluationViewColumnClassName}>
                                            <span className="text-sm white-space-nowrap">{ratedQuestionnairesCountLabel}</span>
                                        </div>
                                    )}
                                </div>
                                <div style={evaluationActionsLayoutStyle}>
                                    {hasCallEvaluationCreatePermission && (
                                        <Button
                                            label="Оцінити дзвінок"
                                            onClick={openEvaluationDialog}
                                        />
                                    )}
                                    {!qualityControlMode && hasCallEvaluationViewPermission && (
                                        <div className={evaluationViewColumnClassName}>
                                            {hasRatedQuestionnaires && (
                                                <Button
                                                    label="Переглянути оцінку"
                                                    icon="pi pi-eye"
                                                    disabled={!statisticData?.id}
                                                    onClick={() => handleViewEvaluation()}
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {hasPlayerVisiblePermission ? <>{!audioUrl && (
                            <div className="field col-12 md:col-12 flex align-items-center justify-content-center">
                                <Button disabled={statisticData?.status === 101 || statisticData?.status === 102}
                                        className="mt-3 flex align-items-center" loading={audioUrlLoading}
                                        onClick={() => handlePlay()}><p className="pl-1 m-0">Прослухати запис
                                    дзвінка</p>
                                </Button>
                            </div>)}
                            {audioUrl && (<div
                                className={`field col-12 md:col-12 flex flex-column align-items-center relative absolute outline-none border-none shadow-none border-circle save-mp3 text-lg mt-3 ${!audioUrl && 'opacity-40'}`}>
                                <Dropdown disabled={loader || !isDropdownEnabled} filter value={isSpeakingAudio}
                                          onChange={(e) => dispatch(setIsSpeacking(e.value))} options={audioOptions}
                                          optionLabel="name"
                                          className="w-full mt-2 mb-3"/>
                                {hasPlayerUpdatePermission && <Button
                                    onClick={() => dispatch(uploadTempUrl(jwtToken?.jwtToken, statisticData?.sessionId, statisticData?.id, isSpeakingAudio))}
                                    disabled={!validAudioUrl} icon="pi pi-download"
                                    loading={audioUrlUploadLoading}
                                    className={`absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ${validAudioUrl ? 'opacity-100' : 'opacity-50'}`}
                                />}
                                <div className="w-full">
                                    <AudioPlayer audioUrl={validAudioUrl} handleResetPlayer={props.handleResetPlayer}
                                                 timeStamp={timeStamp}
                                                 setTimeStamp={setTimeStamp}/>
                                </div>
                            </div>)}
                        </> : ''}
                    </React.Fragment>
                )}
            </div>
            <AudioControlDialog/>
            {hasCallEvaluationPermission && (
                <>
                    {hasCallEvaluationCreatePermission && (
                    <ManualEvaluationDialog
                        visible={evaluationVisible}
                        onHide={closeEvaluationDialog}
                        audioControlId={getStatisticQualityControlId()}
                        callId={statisticData?.id}
                        sessionId={statisticData?.sessionId}
                        callStatus={statisticData?.status}
                        transcription={statisticData?.transcription}
                        validAudioUrl={validAudioUrl}
                        audioUrl={audioUrl}
                        audioUrlLoading={audioUrlLoading}
                        hasPlayerVisiblePermission={hasPlayerRecordingVisiblePermission}
                        onLoadAudio={handlePlay}
                        handleResetPlayer={props.handleResetPlayer}
                        manualInitialEvaluation={statisticData?.manualEvaluation}
                        aiInitialEvaluation={statisticData?.aiEvaluation}
                        onEvaluate={handleEvaluationSubmitted}
                    />
                    )}
                    {hasCallEvaluationViewPermission && (
                    <ControlResultViewDialog
                        visible={controlResultVisible}
                        onHide={() => setControlResultVisible(false)}
                        callId={statisticData?.id}
                        audioControlId={
                            (qualityControlMode ? selectedRatedQuestionnaireId : null)
                            ?? evaluatedAudioControlId
                            ?? getStatisticQualityControlId()
                        }
                        sessionId={statisticData?.sessionId}
                        callStatus={statisticData?.status}
                        transcription={statisticData?.transcription}
                        validAudioUrl={validAudioUrl}
                        audioUrl={audioUrl}
                        audioUrlLoading={audioUrlLoading}
                        hasPlayerVisiblePermission={hasPlayerRecordingVisiblePermission}
                        onLoadAudio={handlePlay}
                        handleResetPlayer={props.handleResetPlayer}
                    />
                    )}
                </>
            )}
        </div>
    );
};

export default StatisticsListDetails;
